module.exports = __webpack_public_path__ + "static/media/23.4930d031.jpg";